// @flow
import React from 'react'
import { Cover } from 'components/cover/base'

import { srcSetConfiguration } from '../srcsets/'
import type { BaseCoverProps } from 'components/cover/types'

export function ImageCover (props: BaseCoverProps) {
  let supportsObjectFit =
    window.CSS &&
    window.CSS.supports &&
    window.CSS.supports('object-fit', 'cover')

  return (
    <Cover {...props}>
      {supportsObjectFit && (
        <img
          style={{
            height: props.coverHeight
          }}
          className='poster image'
          src={props.poster.images[3].path}
          srcSet={props.poster.srcSet}
          sizes={srcSetConfiguration.fullWidthSizeHint}
          alt=''
        />
      )}

      {!supportsObjectFit && (
        <div
          className='poster fallback'
          style={{
            height: props.coverHeight,
            backgroundImage: `url(${props.poster.images[3].path})`
          }}
        />
      )}
    </Cover>
  )
}



// WEBPACK FOOTER //
// ./src/components/cover/image.js